import { getAmpConfig } from 'shared/config/amp-config';

export const getClientStateUrl = () =>
  `${getAmpConfig().gateway}/client-state-service/state`;

export const WALKTHROUGH_STATUS_KEY_V2 = 'walkthrough-status-v2';

export enum ClientStateTags {
  WALKTHROUGH = 'Walkthrough',
}
